import React, { useMemo } from 'react';
import { useAppContext } from '../../Services/AppContext';
import { useState } from 'react';
import SearchWorkplaceDoctor from '../SearchWorkplaceDoctor/SearchWorkplaceDoctor';
import apiClient from '../../Services/ApiClient';
import SearchWorkplace from '../SearchWorkplace/SearchWorkplace';
import { useGetUserOriginalIdQuery } from '../../graphql/graphql';

export default function PatientUserRelationAdd(props) {
	const { userId, handleReload, v2template = false } = props;
	const { translation } = useAppContext();
	const [newItem, setNewItem] = useState(null);
	const [workplace, setWorkplace] = useState(null);
	const user = useGetUserOriginalIdQuery({ id: userId });

	const originalId = useMemo(() => {
		return user?.data?.user?.originalId ?? undefined;
	}, [user]);

	// @ts-ignore
	const handleChanged = async item => {
		setNewItem(item);
	};

	// @ts-ignore
	const handleSetWorkplace = async item => {
		setWorkplace(item);
	};

	// @ts-ignore
	const handleSaveRelation = async () => {
		await apiClient.post('/user-relations/', {
			userId: originalId,
			relationUserId: newItem.user.id,
			workplaceId: newItem.workplace.id,
			type: 'mou',
		});
		if (handleReload) {
			handleReload();
		}
	};

	if (v2template) {
		return (
			<div className='patient-profile__panel__content__attending-doctors__item'>
				{!workplace && (
					<div
						className='input-with-button-group'
						style={{ maxWidth: '500px' }}>
						<SearchWorkplace
							handleClick={handleSetWorkplace}
							gqlParams={{}}
							hideEmptySearch={true}
						/>
					</div>
				)}
				{workplace && (
					<>
						<div className='patient-profile__panel__content__attending-doctors__item__title'>
							{workplace.name || null}
							<div
								onClick={() => handleSetWorkplace(null)}
								className='patient-profile__panel__content__attending-doctors__item__button'>
								{translation['base.change']}
							</div>
						</div>
						<div
							className='input-with-button-group'
							style={{ maxWidth: '500px' }}>
							<SearchWorkplaceDoctor
								handleClick={handleChanged}
								gqlParams={{ workplaceId: workplace.id }}
								hideEmptySearch={true}
								changeButton={handleSaveRelation}
								changeText={translation['base.shared.add']}
							/>
						</div>
					</>
				)}
			</div>
		);
	}

	return (
		<div className='patient-profile__panel__content__attending-doctors__item'>
			{!workplace && (
				<div className='input-with-button-group'>
					<SearchWorkplace
						handleClick={handleSetWorkplace}
						gqlParams={{}}
						hideEmptySearch={true}
					/>
				</div>
			)}
			{workplace && (
				<>
					<div className='patient-profile__panel__content__attending-doctors__item__title'>
						{workplace.name || null}
						<div
							onClick={() => handleSetWorkplace(null)}
							className='patient-profile__panel__content__attending-doctors__item__button'>
							{translation['base.change']}
						</div>
					</div>
					<div className='input-with-button-group'>
						<SearchWorkplaceDoctor
							handleClick={handleChanged}
							gqlParams={{ workplaceId: workplace.id }}
							hideEmptySearch={true}
							changeButton={handleSaveRelation}
							changeText={translation['base.shared.add']}
						/>
					</div>
				</>
			)}
		</div>
	);
}
